import { Drawer, styled } from '@mui/material';
import { forwardRef, useEffect, useRef } from 'react';
import Box from 'shell/components/Box';

const DEVICES = ['mobile', 'tablet', 'desktop'];

const CustomDrawer = styled(Drawer)(({ theme }) => {
    return {
        overflowY: 'hidden',
        '& .MuiBackdrop-root': {
            borderRadius: 0,
            background: 'transparent',
        },
        '& > .MuiPaper-root': {
            borderRadius: 0,
            boxShadow: theme.palette.ensightful.shadows[2],
        },
    };
});

const DrawerInner = styled(Box)(({ theme, device, variant }) => {
    const width = {
        mobile: '100vw',
        tablet: '365px',
        desktop: '710px',
    }[device];

    return {
        width,
        padding: theme.spacing(5),
        overflowY: 'auto',
        ...((variant === 'persistent' || device !== 'mobile') && { marginTop: theme.spacing(16) }),
    };
});

export default forwardRef(({ children, device = 'tablet', variant, ...rest }, ref) => {
    if (!DEVICES.includes(device)) throw new Error(`Shell: Invalid device "${device}" in component Drawer.`);

    const drawerInnerRef = useRef(null);

    useEffect(() => {
        if (rest.open && drawerInnerRef.current) drawerInnerRef.current.scrollTo(0, 0);
    }, [rest.open]);

    return (
        <CustomDrawer
            ref={ref}
            transitionDuration={300}
            role={variant !== 'persistent' && rest.open ? 'main' : 'region'}
            variant={variant}
            {...rest}
        >
            <DrawerInner ref={drawerInnerRef} device={device} variant={variant}>
                {children}
            </DrawerInner>
        </CustomDrawer>
    );
});
